import { Injectable } from '@angular/core';
import { HttpProvider } from "../http/http";

/*
  Generated class for the NotificationProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class NotificationProvider {

  constructor(public http: HttpProvider) {
    console.log('Hello NotificationProvider Provider');
  }

  getNotiList(type?, read?) {
    let params = {
      type: type,
      read: read
    };
    return this.http.hPost('/user/get_notification_list', params);
  }

  setNotiStatus(notification_id) {
    let params = {
      notification_id: notification_id
    };
    return this.http.hPost('/user/set_notification_read', params);
  }

  deleteNoti(notification_id_list?, type?) {
    let params = {
      notification_id_list: notification_id_list,
      type: type,
    };
    return this.http.hPost('/user/set_notification_read', params);
  }
}



// WEBPACK FOOTER //
// ./src/providers/notification/notification.ts